import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWallet2"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM4.5 7.5C4.5 6.94772 4.94772 6.5 5.5 6.5H18.5C19.0523 6.5 19.5 6.94772 19.5 7.5V10H16.0182L13.8237 11.5H10.1763L7.98184 10H4.5V7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet2;
